import { Injectable, inject } from '@angular/core';
import { RUNTIME_CONFIG, RuntimeConfig } from './runtime-config';

@Injectable({
  providedIn: 'root',
})
export class MediaStorageService {
  private readonly runtimeConfig = inject<RuntimeConfig>(RUNTIME_CONFIG);

  buildImageUrl(path: string | null | undefined, size = '800:600'): string {
    const normalizedPath = typeof path === 'string' ? path.trim() : '';

    if (!normalizedPath) {
      return '';
    }

    if (this.isExternalImage(normalizedPath)) {
      return normalizedPath;
    }

    const baseUrl = this.runtimeConfig.mediaStorageUrl.replace(/\/+$/, '');
    const source = this.runtimeConfig.mediaStorageSource;
    const filename = normalizedPath.replace(/^\/+/, '');
    return `${baseUrl}/insecure/rs:fit:${size}:no:0/plain/${source}${filename}`;
  }

  private isExternalImage(path: string): boolean {
    return (
      path.startsWith('http://') ||
      path.startsWith('https://') ||
      path.startsWith('data:') ||
      path.startsWith('blob:')
    );
  }
}
